module.exports = __webpack_public_path__ + "static/img/sence1.1e0bbda.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/home/pc/index1/sence1.jpg
// module id = pwhF
// module chunks = 7